import { useState, useRef, useEffect } from 'react';
import useOutsideClick from '../../../hooks/useOutsideClick';

export default function useFixedCardMenu() {
    const menuRef = useRef(null);
    const [showMenu, setShowMenu] = useState({ flag: false });
    const [menuCoordinates, setMenuCoordinates] = useState({ x: 0, y: 0 });

    useOutsideClick(menuRef, () => {
        if (showMenu.flag) {
            setShowMenu({});
        }
    });

    useEffect(() => {
        if (showMenu.flag) {
            window.addEventListener('scroll', toggleShowMenu);
        } else {
            window.removeEventListener('scroll', toggleShowMenu);
        }
        return () => {
            window.removeEventListener('scroll', toggleShowMenu);
        };
    }, [showMenu])

    const toggleShowMenu = () => setShowMenu({});

    const onOpenMenu = (props = {}) => {
        const { id = null, clientX = 0, clientY = 0, ...args } = props;
        if (!id) {
            setShowMenu({});
            return;
        }
        setShowMenu({
            id,
            flag: true,
            ...args,
        });
        setMenuCoordinates({ x: clientX, y: clientY });
    };

    return { menuRef, showMenu, menuCoordinates, onOpenMenu, toggleShowMenu };
}
